export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40375bb872a8c025a2fd96cd6f8c3f4baebc663a21&name=revalidateCommunity!'